import * as React from 'react';
import AboutUs from '../components/AboutUs';
import Slideshow from '../components/Slideshow';
import Mission from '../components/Mission';
import People from '../components/People';
import Partner from '../components/Partner';

class Home extends React.PureComponent {
  render(): JSX.Element {
    return (
      <div>
        <Slideshow />
        <AboutUs />
        <Mission />
        <People />
        <Partner />
      </div>);
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/page/Home.tsx